import React, { useState } from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';

function NotFound() {
    const navigate = useNavigate();

    return (
        <Result
            status="404"
            title="404"
            subTitle="Xin lỗi, trang bạn truy cập không tồn tại."
            extra={
                <Button type="primary" onClick={() => navigate('/')}>
                    Quay lại trạng chủ
                </Button>
            }
        />
    );
}

export default NotFound;
